import React from "react";
import { Link, useLocation } from "react-router-dom";

const Header: React.FC = () => {
  const location = useLocation();
  const isTrackerPage = location.pathname === "/kyros-time-tracker";

  return (
    <header className="sticky top-0 z-20">
      <div
        className={`backdrop-blur-md border-b ${
          isTrackerPage
            ? "bg-white border-white/10"
            : "bg-white border-white/20"
        }`}
      >
        <div className="container-max py-4 px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <Link
            to="/"
            className="hover:opacity-80 transition-opacity flex items-center"
          >
            <img
              src="/kyros-tech-logo.png"
              alt="Kyros Tech Logo"
              className="h-auto w-[150px]"
            />
          </Link>
          {isTrackerPage ? (
            <a href="#waitlist" className="btn-primary text-sm px-5 py-2">
              Join Waitlist
            </a>
          ) : (
            <a href="#quote" className="btn-primary text-sm px-5 py-2">
              Contact
            </a>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
